module.exports = __webpack_public_path__ + "files/0e6911dc56c765fbea32263b9e737096.svg";